// extracted by mini-css-extract-plugin
module.exports = {"Burger":"Burger_Burger__m2MjJ","noIngredients":"Burger_noIngredients__8lxTI"};